import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ErrorLogger, StateMap, UnitOfWork, UserManager } from '../../services/common';
import { TabContainer } from '../../controls/common';
import { LocationFns, UtilFns } from '../../utils/common';
import { ExposureSurvey } from '../../entities/EntityModels';
import { MaterialExposureSurveysComponent } from './material-exposure-surveys.component';
import { EXPOSURE_ROUTES } from './exposure.routes';

import * as _ from 'lodash';
import {Observable, Subject} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';

export class ExposureEditData {
    inSubEditor: boolean;
    currentTab: number;
}

@Component({
    selector: 'exposure-survey-lists',
    templateUrl: './exposure-survey-lists.html',
})

export class ExposureSurveyListsComponent implements OnInit {
    @ViewChild(MaterialExposureSurveysComponent) _materialExposureSurveysComponent: MaterialExposureSurveysComponent;
    @ViewChild(TabContainer) _tabContainer: TabContainer;
    _tab: number;

    public _data: ExposureEditData = new ExposureEditData();
    private _isLoading: boolean;
    private _navparam: number;

    public _selectedExposureSurveyIndex: number;
    public _selectedExposureSurvey: ExposureSurvey;
    public _exposureSurveys: ExposureSurvey[] = [];

    public _documentManagementUrl: string;
    public _validationMessage: string;

    constructor(private _uow: UnitOfWork, private _stateMap: StateMap, private _userManager: UserManager, private _router: Router,
                public _route: ActivatedRoute, public _location: Location, public _errorLogger: ErrorLogger, private _httpClient: HttpClient) {

    }

    ngOnInit() {

        this._stateMap.currentRouteName = EXPOSURE_ROUTES.ExposureSurveyLists.name;

        this._route.params.subscribe(params => {
            this._navparam = +params['id']; // exposure survey id
        });

        this.fetch();

        this._tab = LocationFns.getTab(this._location) || 0;

        this._uow.getDocumentManagementUrl().then(url => {
            this._stateMap.documentManagementBaseUrl = url;
            this._documentManagementUrl = this._stateMap.documentManagementBaseUrl  + '/Report';
        });
    }

    fetch() {

        let filterId = 0;

        this._exposureSurveys = [];

        this._isLoading = true;

        this._uow.fetch('ExposureSurveys/ExposureSurveys', {})
            .then(e => {
                this._exposureSurveys = e;
                if (this._exposureSurveys != null && this._exposureSurveys.length > 0) {
                    if (!isNaN(this._navparam)) {   // Filter to navigation param of exposuresurveyid instead of first in the array.
                        filterId = this._exposureSurveys.findIndex(x => x.exposureSurveyId == this._navparam);
                    }
                    this.filterExposureSurveyByIndex(filterId); // Set default Exposure Survey to the first in the list.
                }
                this._isLoading = false;
            });
    }

    // Filters
    filterExposureSurveyByIndex(ix: number) {
        this._selectedExposureSurveyIndex = ix;
        this._selectedExposureSurvey = this._exposureSurveys[ix];

        if (this._materialExposureSurveysComponent != null) {
            this._materialExposureSurveysComponent.onSurveyChange(this._selectedExposureSurvey);
        }

        setTimeout(() => {
            this._tabContainer.selectTab(0);
        }, 1);

    }

    canDeactivate() {
        return !this._data.inSubEditor && !this._uow.hasChanges();
    }

    get isLoading() {
        return this._isLoading;
    }

    set isLoading(value) {
        this._isLoading = value;
    }

    isStaff() {
        return this._stateMap.currentUser.isStaff;
    }

    get utilFns() {
        return UtilFns;
    }

    // Reports
    onExportCremeReport() {
        return this.exportReportFile(this._selectedExposureSurvey.exposureSurveyId, 'CremeReport.csv', 'creme');
    }

    onExportFullSurveyReport() {
        return this.exportReportFile(this._selectedExposureSurvey.exposureSurveyId, 'ExposureSurveyMaterials.csv', 'exposuresurveymaterials');
    }

    // Navigation
    onShowExposureSurvey() {

        if (this._selectedExposureSurvey == null) {
            return;
        }

        this._router.navigate(['../exposure-surveys', { id: this._selectedExposureSurvey.exposureSurveyId }], { relativeTo: this._route });
    }

    // ************************************************************************
    // document management web api url
    // ************************************************************************
    getDownloadFileURL(exposureSurveyId: number, reportType: string): Observable<any> {
        let url: string;

        if (reportType == 'creme') {
            url = this._documentManagementUrl + '/GetCremeReportFile?exposureSurveyId=' +  exposureSurveyId;
        } else if (reportType == 'exposuresurveymaterials') {
            url = this._documentManagementUrl + '/GetExposureSurveyMaterialReportFile?exposureSurveyId=' +  exposureSurveyId;
        }

        return this._httpClient.get<any>(url, { responseType: 'blob' as 'json'});
    }

    public exportReportFile(exposureSurveyId: number, fileName: string, reportType: string) {
        this._isLoading = true;
        this._validationMessage = '';
        this.getDownloadFileURL(exposureSurveyId, reportType)
            .subscribe(
                (response: Blob) => {
                    const data = response;

                    const file = new Blob([data], { type: 'text/plain;charset=utf-8;' });
                    const fileURL = URL.createObjectURL(file);

                    const a         = document.createElement('a');
                    a.href        = fileURL;
                    a.target      = '_blank';
                    a.download    = fileName;
                    document.body.appendChild(a);
                    a.click();

                    a.remove();

                    window.URL.revokeObjectURL(fileURL);

                    this._validationMessage = 'File download successful.';

                },
                (error) => {
                    console.error('Request failed with error: ' + error.message);
                    this._validationMessage = error.message;
                    this._isLoading = false;
                },
                () => {
                    this._isLoading = false;
                });
    }
}
